import React from "react";

import Form from "../Components/SmartForm/Form";
import Input from "../Components/SmartForm/Input";
import Label from "../Components/SmartForm/Label";

const ForgotPasswordForm = (props) => {

    return (
        <Form
            id="forgot-password-form"
            action="/customer/account/forgotPassword"
            method="post"
            {...props}
        >
            <div className="col-12">
                <Label
                    input="email"
                    required
                >
                    Email Address
                </Label>
                <Input
                    name="email"
                    label="Email Address"
                    type="email"
                    className="form-control"
                    placeholder="email@email.com"
                    required
                />
            </div>
            <div className="col-12 d-flex justify-content-between">
                <button type="submit" className="btn btn-lx">
                    <i className="fas fa-lock-alt"></i>
                    Submit
                </button>
                <a className="mt-2 d-block" href="/cms/contact-us">Need assistance?</a>
            </div>
        </Form>
    );
};

export default ForgotPasswordForm;
